<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-btn @click="getData" :loading="loading">Получить данные</v-btn>
      <!--</v-card>-->
      <div v-if="iikoData" class="iiko-data">
        <ul>
          <li><b>Iiko id: </b> {{ iikoData.id }}</li>
          <li><b>Телефон: </b> {{ iikoData.phone }}</li>
          <li><b>Имя: </b> {{ iikoData.name }} {{ iikoData.surname}}</li>
          <li><b>День рождения: </b> {{ iikoData.birthday }}</li>
          <li v-for="wallet in iikoData.walletBalances"><b>Бонусы "{{ wallet.name }}": </b> {{ wallet.balance }}</li>
        </ul>
      </div>
    </v-col>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import ReviewService from '../../../api/ReviewService'
    import UserService from "@/api/UserService";

    export default {
        name: 'ReviewUserIndex',
        props: {
          value: Object,
        },
        components: {},
      data() {
        return {
          user: this.value,
          iikoData: null,
          loading: false
        }
      },
        mounted() {
        },
        watch: {

        },
        methods: {
          getData(){
            this.loading = true
            UserService.getIikoData(this.user.id)
                .then(response => {
                  this.iikoData = response.data;
                  this.loading = false
                });
          }
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .iiko-data{
    margin-top: 32px;
    ul{
      li{
        display: block;

      }
    }
  }
</style>
